import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=37f203cf&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f203cf')) {
      api.createRecord('37f203cf', component.options)
    } else {
      api.reload('37f203cf', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=37f203cf&", function () {
      api.rerender('37f203cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xk3dB1wF8JIt/JS/imageCarousel.vue"
export default component.exports